module.exports = __webpack_public_path__ + "img/pv_darkmode.408474eb.png";